// eslint-disable-next-line import/prefer-default-export
export const muiListComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing('NONE'),
    }),
  },
};
